export const PREFERENCE_LEVEL_PREFERRED = 10;
export const PREFERENCE_LEVEL_NON_PREFERRED = 0;
